export default __webpack_public_path__ + "static/media/AddUser.86a0dc08.svg";